import api from './api';

const produccionGuiaService = {
  async formOptions() {
    const response = await api.get('/produccion/guias/form-options');
    return response.data;
  },

  async template(guideType, params = {}) {
    const response = await api.get('/produccion/guias/plantilla', {
      params: { guide_type: guideType, ...params },
    });
    return response.data;
  },

  async list(params = {}) {
    const response = await api.get('/produccion/guias', { params });
    return response.data;
  },

  async get(id) {
    const response = await api.get(`/produccion/guias/${id}`);
    return response.data;
  },

  async create(payload) {
    const response = await api.post('/produccion/guias', payload);
    return response.data;
  },

  async update(id, payload) {
    const response = await api.put(`/produccion/guias/${id}`, payload);
    return response.data;
  },

  async remove(id) {
    const response = await api.delete(`/produccion/guias/${id}`);
    return response.data;
  },

  async sacarAProduccion(id, payload) {
    const response = await api.post(`/produccion/guias/${id}/sacar-a-produccion`, payload);
    return response.data;
  },

  async revertirSalidaProduccion(id) {
    const response = await api.post(`/produccion/guias/${id}/revertir-salida-produccion`);
    return response.data;
  },

  async getDashboard(params = {}) {
    const response = await api.get('/produccion/dashboard', { params });
    return response.data;
  },
};

export default produccionGuiaService;
